import { createGlobalStyle } from 'styled-components/macro';
import { modalIsOpenClassName } from '../shared/Modal';
import { colourNeutral01 } from './colours';
import { fontFamily, fontSize02 } from './fonts';

export const GlobalStyles = createGlobalStyle`
  html,
  body {
    margin: 0;
    font-family: ${fontFamily};
    font-size: ${fontSize02};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${colourNeutral01};
  }
  
  html.${modalIsOpenClassName} {
    overflow-y: hidden;
    
    body {
      overflow-y: scroll;
    }
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  pre {
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
  }
`;
